import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./LoginWithMPIN.scss";
import LockImage from "../../../assets/images/login-lock.svg";
import {
  useLazyGenerateOtpQuery,
  useLazyValidateMpinDataQuery,
} from "../Login_Api";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { updateLoginData, updateScreenTag } from "../Login_Slice";
import CsLocalStorageUtils from "../../../utils/CsLocalStorageUtils";
import { updateLoadingState } from "../../Feature_Loading/Loading_Slice";
import {
  generateDeviceID,
  getMobileOperatingSystem,
  defaultEmptyFun,
  getValidEmailFromCustomerAndLobDetails,
} from "../../../utils/helper";
import { API_STATUS_CODE } from "../../../utils/ApiEndpoints";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import clevertap from "../../../utils/CleverTap";
import CustomThreeDotsLoader from "../../../components/CustomThreeDotsLoader/CustomThreeDotsLoader";
import { R_HomeRoutes } from "../../../utils/Routes";
import {
  LoginScreenValues,
  T_ApiResponse,
} from "../../../globalTypes/GlobalTypes";
import { MuiOtpInput } from "mui-one-time-password-input";
import CustomErrorPopup from "../../../pages/AddManuallyPopup/CustomErrorPopup";
import { isEmpty } from "lodash";

const LoginWithMPIN: React.FC = () => {
  const navigate = useNavigate();
  const [mpin, setMpin] = useState<string>("");
  const [validateMpinApi, mpinApiRes] = useLazyValidateMpinDataQuery();
  const appDispatch = useAppDispatch();

  const [showErrorPopUp, setShowErrorPopUp] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState<string | undefined>(
    ""
  );
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const loginSlice = useAppSelector((state) => state.LoginSlice);
  let customerAndLobDetails =
    loginSlice.csAndLobDetails?.payload.customerAndLobDetails || [];
  let customerEmailFromLobDetails = getValidEmailFromCustomerAndLobDetails(
    customerAndLobDetails
  );
  const [generateOtpApi] = useLazyGenerateOtpQuery();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOnChangeMpin = (value: string) => {
    setMpin(value);
    if (value.length === 4) {
      validateMpin(value);
    }
  };

  const forgotMPN = () => {
    appDispatch(updateScreenTag(LoginScreenValues.enterOtpScreenForgotmPIN));
  };

  const useOTP = () => {
    //appDispatch(updateScreenTag(LoginScreenValues.enterOtpScreen));
    generateOtpFun();
  };

  const generateOtpFun = async () => {
    setIsLoading(true);
    const mobileNo = CsLocalStorageUtils.get("MOBILE");
    const email = CsLocalStorageUtils.get("EMAIL");
    await generateOtpApi({
      mobileNo: "" + mobileNo,
      otp: "",
      emailId: customerEmailFromLobDetails || email,
    }).then((res) => {
      setIsLoading(false);
      if (res.isSuccess && res.data?.code === 1) {
        appDispatch(
          updateLoginData({
            key: "mobilenumber",
            value: mobileNo,
          })
        );
        appDispatch(updateScreenTag(LoginScreenValues.enterOtpScreen));
      } else if (res.isError && res.error) {
        let newError = res.error as T_ApiResponse<any>;
        if (newError.code && newError.code === 2) {
          setIsLoading(false);
          setShowErrorPopUp(true);
          setShowErrorMessage(newError?.rootCause);
        } else {
          setIsLoading(false);
          appDispatch(
            setError({
              error: res.error as T_ApiResponse<any>,
              message: "failed",
            })
          );
        }
      }
      appDispatch(updateLoadingState(false));
    });
  };

  const validateMpin = (mpinValue: string) => {
    appDispatch(updateLoadingState(true));

    const mobileNo = CsLocalStorageUtils.get("MOBILE");
    const csUserId = CsLocalStorageUtils.get("CS_USER_ID");
    validateMpinApi({
      csUserId: csUserId,
      mpin: mpinValue || "",
      mobileNo: mobileNo,
      deviceType: getMobileOperatingSystem(),
      deviceId: generateDeviceID(),
    }).then((res) => {
      if (res.data?.code === API_STATUS_CODE.SUCCESS) {
        appDispatch(updateLoginData({ key: "isUserLoggedIn", value: true }));
        appDispatch(
          updateLoginData({
            key: "mobilenumber",
            value: mobileNo,
          })
        );
        if (isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)) {
          clevertap.onUserLogin.push({
            Site: {
              Identity: csUserId, // String or number
              Phone: "+91" + mobileNo,
            },
          });
        }
        navigate(R_HomeRoutes.home, { replace: true });
      } else if (res.data?.code === API_STATUS_CODE.ERROR) {
        appDispatch(
          setError({
            error: res.data,
            message: "Something went wrong",
          })
        );
        appDispatch(updateLoadingState(false));
      } else if (res.data?.code === API_STATUS_CODE.BUSINESS_ERROR) {
        setMpin("");
        const mpinContainer = document.querySelector(
          ".MuiOtpInput-TextField-1"
        );
        if (mpinContainer) {
          const inputElement = mpinContainer.querySelector("input");
          if (inputElement) {
            inputElement.focus();
          }
        }
        appDispatch(updateLoadingState(false));
      } else {
        appDispatch(updateLoadingState(false));
      }
    });
  };

  return (
    <Box paddingTop="0.5rem">
      <Box display="flex" justifyContent="center">
        <img src={LockImage} alt="Lock Icon" />
      </Box>
      <Box>
        <Typography
          fontWeight={700}
          fontSize={24}
          marginTop="1.5rem"
          marginBottom=".25rem"
          lineHeight={"1.8rem"}
          align="center"
        >
          {"Welcome to ABC"}
        </Typography>
        <Typography
          fontSize={14}
          marginTop=".25rem"
          marginBottom=".375rem"
          fontWeight={400}
          lineHeight={"1.2rem"}
          color={"rgba(121, 121, 121, 1)"}
          align="center"
        >
          {"Enter mPIN to log in"}
        </Typography>

        <Box
          display="flex"
          flexDirection="column"
          width="fit-content"
          marginX="auto"
        >
          <MuiOtpInput
            className={`mpin-input `}
            length={4}
            value={mpin}
            onChange={handleOnChangeMpin}
            validateChar={(char) => /^[0-9]$/.test(char)}
            TextFieldsProps={{
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
              },
            }}
          />

          {mpinApiRes.data?.code === API_STATUS_CODE.BUSINESS_ERROR && (
            <Box display="flex" justifyContent="center">
              <Typography color="error" marginTop="1rem">
                {mpinApiRes?.data?.uiDisplayMessage || "MPIN validation failed"}
              </Typography>
            </Box>
          )}
        </Box>

        <Typography
          fontSize={14}
          marginTop="1rem"
          fontWeight={500}
          lineHeight={"1.05rem"}
          color={"rgba(199, 34, 42, 1)"}
          align="center"
          onClick={forgotMPN}
        >
          {"Forgot mPIN?"}
        </Typography>

        {isLoading ? (
          <CustomThreeDotsLoader withText={true} />
        ) : (
          <Typography
            fontSize={12}
            marginTop="1rem"
            fontWeight={600}
            lineHeight={".975rem"}
            color={"rgba(199, 34, 42, 1)"}
            align="center"
            onClick={useOTP}
          >
            {"Use OTP instead"}
          </Typography>
        )}
      </Box>{" "}
      {showErrorPopUp && (
        <CustomErrorPopup
          open={showErrorPopUp}
          handleOpen={setShowErrorPopUp}
          errorMessage={showErrorMessage}
        />
      )}
    </Box>
  );
};

export default LoginWithMPIN;
